import { BrokerModel } from '../../../api/admin/admin.types';
import { Action } from 'redux';
import { Page } from '../../../api/api.types';

export const GET_BROKER_LIST = 'GET_BROKER_LIST';
export const GET_BROKER = 'GET_BROKER';
export const POST_BROKER = 'POST_BROKER';
export const PUT_BROKER = 'PUT_BROKER';
export const DELETE_BROKER = 'DELETE_BROKER';

export interface BrokerState {
  brokers: BrokerModel[] | [];
  selectedBroker: BrokerModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
}

export interface GetBrokerListAction extends Action {
  type: typeof GET_BROKER_LIST;
  payload: {
    page: Page<BrokerModel>;
  };
}

export interface GetBrokerAction extends Action {
  type: typeof GET_BROKER;
  payload: {
    selectedBroker: BrokerModel | null;
  };
}

export interface PostBrokerAction extends Action {
  type: typeof POST_BROKER;
  payload: {
    success: boolean;
    newBroker: BrokerModel | null;
  };
}

export interface PutBrokerAction extends Action {
  type: typeof PUT_BROKER;
  payload: {
    selectedBroker: BrokerModel;
  };
}


export type BrokerActionTypes =
  GetBrokerListAction
  | GetBrokerAction
  | PostBrokerAction
  | PutBrokerAction;